import type {
  ChipListItem,
  FilterListBody,
  SearchChipItem,
  ToggleChipItem,
} from './types';

function isToggleChipItem(chip: ChipListItem): chip is ToggleChipItem {
  return chip?.type === 'toggle';
}
function isSearchChipItem(chip: ChipListItem): chip is SearchChipItem {
  return chip?.type === 'search';
}

export function chipListGenerator(
  chipList: NonNullable<FilterListBody['chip']>['chip_list'],
): Array<FilterListChip> {
  return chipList.map(chip => {
    if (isToggleChipItem(chip)) {
      return {
        type: 'toggle',
        text: chip.text,
        label: chip.text,
        value: chip.is_selected,
        loggingText: chip.logging_text,
        queryName: chip.query_name,
        queryValue: chip.query_value,
      };
    }

    if (isSearchChipItem(chip)) {
      return {
        type: 'search',
        text: chip.text,
        label: chip.text,
        value: chip.is_selected,
        loggingText: chip.logging_text,
        queryName: chip.query_name,
        searchHint: chip.search_hint,
      };
    }

    return {
      type: 'select',
      text: chip.text,
      label: chip.text,
      value: chip.is_selected,
      filterToken: chip.filter_token,
      loggingText: chip.logging_text,
    };
  });
}

export type FilterListChip =
  | {
      type: 'toggle';
      text: string;
      label: string;
      value: boolean;
      loggingText: string;
      queryName: string;
      queryValue: string;
    }
  | {
      type: 'select';
      text: string;
      label: string;
      value: boolean;
      loggingText: string;
      /** screensService.getFilterOptions에 전달할 토큰 */
      filterToken: string;
    }
  | {
      type: 'search';
      text: string;
      label: string;
      value: boolean;
      loggingText: string;
      queryName: string;
      searchHint: string;
    };
